import { IFormViewForm } from 'components/FormView';

const SlipDetails: IFormViewForm = {
  id: 'SlipDetails',
  layout: {
    rows: 2,
    columns: 3
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 0,
          type: 'SELECT_FIELD',
          visible: true,
          props: {
            label: 'Priority',
            name: 'Priority',
            size: 'small',
            hideInV2: true,
            apiPrefs: {
              LookupType: 'Dynamic',
              path: '/CustomTypes/Lookup/Priority/Search',
              method: 'POST'
            },
          }
        },
        {
          id: 1,
          type: 'SELECT_FIELD',
          visible: true,
          props: {
            label: 'Delivery type',
            name: 'DeliveryType',
            placeholder: '',
            size: 'small',
            apiPrefs: {
              path: '/CustomTypes/Lookup/DeliveryType',
              method: 'GET',
              params: null
            },
          }
        },
        {
          id: 2,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Site',
            size: 'small',
            name: 'Sitecode',
            lookupName: 'DeliverySite',
            suppressDescription: true,
            suppressValidation: true,
            isCustomerScoped: true,
            isLookupTypeFixed: true
          }
        },
        {
          id: 3,
          type: 'ADDRESS_BLOCK_EX',
          visible: true,
          props: {
            label: '',
            name: 'address',
            type: 'extended',
          }
        }
      ]
    },
    {
      id: 1,
      position: {
        row: 1,
        col: 2
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 0,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Freight code',
            name: 'FreightCode',
            size: 'small',
            lookupName: 'FreightCode',
            suppressDescription: true,
            hideInV2: true,
          }
        },
        {
          id: 1,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Send via',
            name: 'SendVia',
            size: 'small',
            lookupName: 'FreightType',
            suppressValidation: true,
            suppressDescription: true,
          }
        },
        {
          id: 2,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Carrier',
            name: 'Carrier',
            suppressValidation: true,
            suppressDescription: true,
            size: 'large',
            lookupName: 'CarrierCode',
          }
        },
        {
          id: 3,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Freight account',
            name: 'FreightAccount',
            size: 'medium',
          }
        },
        {
          id: 4,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Shipping instructions',
            name: 'Shipping',
            size: 'large',
          }
        },
        {
          id: 5,
          type: 'TOGGLE_FIELD',
          visible: true,
          props: {
            label: 'Save delivery and shipping details to customer',
            name: 'SaveDelivery',
          }
        },
      ]
    },
    {
      id: 1,
      position: {
        row: 1,
        col: 3
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 6,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Cartons',
            placeholder: '0',
            alignment: 'left',
            type: 'number',
            name: 'Cartons',
            size: 'small',
          }
        },
        {
          id: 7,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Pallets',
            name: 'Pallets',
            type: 'number',
            alignment: 'left',
            placeholder: '0',
            hideInV2: true,
            size: 'small',
          }
        },
        {
          id: 7,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Weight',
            name: 'Weight',
            placeholder: '0.0000',
            size: 'medium',
            decimalSeparator: true,
            type: 'number',
            decimalPlaces: 4
          }
        },
        {
          id: 8,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Cubic',
            name: 'Cubic',
            placeholder: '0.0000',
            size: 'medium',
            decimalSeparator: true,
            hideInV2: true,
            type: 'number',
            decimalPlaces: 4
          }
        },
        {
          id: 5,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Consignment note',
            name: 'ConsignmentNote',
            placeholder: '',
            size: 'large',
          }
        }
      ]
    },
    {
      id: 1,
      position: {
        row: 2,
        col: 1,
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 0,
          type: 'TEXT_AREA',
          visible: true,
          props: {
            label: 'Despatch comments',
            name: 'Comment',
            placeholder: '',
            size: 'large',
            style: {
              height: '250px'
            }
          }
        }
      ]
    },
  ]
};

export default SlipDetails;
